const locale = {
    search : 'Search',
    logo:'Logo',
    company_logo:'Company Logo',
    members:'Members',
    status:'Status',
    actions: 'Actions',
    multiple_companies: 'Companies',
    head_admin_list:'Head Admin List',
    add_company: 'Add Company',
    details:'Details',
    delete_company:'Delete Company',
    active:'Active',
    inactive:'Inactive',
    activate_company:'Activate Company', 
    company_details: 'Company Details',
    company_id: 'Company ID',
    company_name: 'Company Name',
    domain: 'Domain',
    location: 'Location',
    enter_company_id: 'Enter Company ID',
    enter_company_name: 'Enter Company Name',
    enter_domain: 'Enter Domain',
    enter_location: 'Enter Location',
    add_head_admin: 'Add Head Admin',
    head_admin: 'Head Admin',
    name:'Name',
    email:'Email',
    enter_name:'Enter Name',
    enter_email:'Enter Email',
    please_write_down_the_name_of_the_company_before_action: 'Please right down the name of the Company before action.',
    edit_headAdmin: "Edit Head Admin",
    delete_headAdmin: "Delete Head Admin",
    please_write_down_the_name_of_the_headAdmin_before_action: 'Please right down the name of the Head Admin before action.',
    company_logo_here: 'Company logo here',
    do_you_want_to_activate_this_company:'Do you want to activate this company ?',
    do_you_want_to_delete_this_company:'Do you want to delete this company ?',
    filter:'Filter',
    filter_by:'Filter By:',
    reset_filters:'Reset Filter',
    account_status: 'Account Status',
    cancel:'Cancel',
	delete:'Delete',
	submit:'Submit',
	update:'Update',
    no_matching_records_found: 'No matching records found.',
    please_enter_a_valid_domain: 'Please enter a valid domain',
    something_went_wrong: 'Something went wrong!',
    update_succesfully: 'Update succesfully!',
    removed_succesfully:'Removed succesfully!',
    do_you_want_to_delete_this_head_admin:'Do you want to delete this head admin',
    head_admin_added_succesfully:'Head Admin added succesfully',
    loading:'Loading...',
    this_email_already_exist:'This email already exist!',
    this_name_already_exist: 'This name already exist!',
    this_domain_already_exist:'This domain already exist!',
    company_created_succesfully: 'Company created succesfully!',
    please_create_head_admin:'Please create Head Admin',
    edit_company: 'Edit Company',
    dashboard:'Dashboard',
    connect: 'Connect',
    live_streaming:'Live Streaming',
    mix_calendar:'Mix Calendar',
    contacts: 'Contacts',
    project_map:'Project Map',
    cctv_map: 'CCTV Map',
    choose_services:'Choose Services',
    assign_head_admin: 'Assign Head Admin',
    choose_services_for_menu_sidebar: 'Choose services for menu sidebar',
    please_setup_wich_services_you_want_for_the_company_by_clicking_the_available_checkboxes: 'Please setup which services you want for the Company by clicking the available checkboxes.',

};

export default locale;
